import { createSelector } from 'reselect';
import { isTicketTypeVisible } from '../service/visibilityChecker';
import selectAllTicketTypes from './selectAllTicketTypes';

export default createSelector(
    selectAllTicketTypes,
    ticketTypes => Object.entries(ticketTypes)
        .reduce((accumulator, [key, value]) => {
            if (isTicketTypeVisible(value)) {
                accumulator[key] = value;
            }
            return accumulator;
        }, {}),
);
